/**
 * Sanitizes a reference string by trimming whitespace.
 * @param reference The reference string to sanitize.
 * @returns The sanitized reference string, or null if empty.
 */
export const sanitizeReference = (reference: string | null): string | null => {
  const trimmed = reference?.trim();
  return trimmed && trimmed.length ? trimmed : null;
};
